import { useEffect, useState } from "react";
import { RateCard } from "../types/rateCard";
import { rateCardService } from "../services/rateCard";

interface UseRateCardResult {
  data: RateCard[];
  totalRecords: number;
  loading: boolean;
  error: string | null;
  refetch: () => void;
}

export const useRateCard = (userId?: number | string): UseRateCardResult => {
  const [data, setData] = useState<RateCard[]>([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchRateCard = async () => {
    if (!userId) return;

    try {
      setLoading(true);
      setError(null);

      const res = await rateCardService.getPricingZones(userId);

      setData(res.rateCard);
      setTotalRecords(res.totalRecords);
    } catch (err: any) {
      setError(
        err?.response?.data?.message || "Failed to fetch rate card data"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRateCard();
  }, [userId]);

  return {
    data,
    totalRecords,
    loading,
    error,
    refetch: fetchRateCard,
  };
};
